import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Card from './Card';

const Service = () => {
    const[user,setUser] = useState([]);
    useEffect(() =>{
        const url ='./service.JSON';
        fetch(url)
        .then(res => res.json())
        .then(data=> setUser(data))
    },[])

    return (
        <div className="container">
            <h1 className="text-center">Service</h1>
            <hr className="w-50 m-auto m-3" />
            <div className="row mt-5">
        {
            user.map(use => <Card key={use.tite} user={use}></Card>)
        }
            </div>
        </div>
    );
};

export default Service;